import { Component, ViewChild, HostListener } from '@angular/core';
import { ApiService, NotificationService, AuthService, TohumUiModule, ModalTriggerComponent, TranslateService } from '@anadolu-commons/tohum-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from "@ngneat/transloco";
import { Title } from '@angular/platform-browser';
import { SayacComponent } from "./shared/aof-sayac/aof-sayac.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [TohumUiModule, SayacComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ClientApp';
  girisYapanKullaniciAyniMi = true;
  sayacCalisacakMi = true;
  @ViewChild('oturumModal') oturumModal: ModalTriggerComponent;

  private lastActivityUpdate = 0;

  constructor(private router: Router, private titleService: Title, private apiService: ApiService,
    private notification: NotificationService, private authService: AuthService, private translocoService: TranslocoService,
    private route: ActivatedRoute, private translateService: TranslateService) {
  }

  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  @HostListener('window:scroll')
  updateLastActivity() {
    const now = Date.now();
    if (now - this.lastActivityUpdate > 10000) {
      const last = localStorage.getItem('lastActivityTime');
      if (last) {
        const diff = now - parseInt(last, 10);
        if (diff > 30 * 60 * 1000) {
          localStorage.removeItem('selectedCategory');
          if (this.router.url === '/' || this.router.url === '/ana-sayfa') {
            window.location.reload();
          }
        }
      }
      localStorage.setItem('lastActivityTime', now.toString());
      this.lastActivityUpdate = now;
    }
  }
  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      
      const lang = params['lang'];
    
      if (lang) {

        const currentParams = { ...params };
        delete currentParams['lang'];

        // 1. önce URL'den lang parametresini kaldır
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: currentParams,
          replaceUrl: true
        }).then(() => {

          if (this.translateService.getLang() !== lang) {
            // 2. sonra setLang çağrılır ve sayfa refresh edilir
            this.translateService.setLang(lang);
          }
        });

      }
    });

    this.translocoService.selectTranslate('giris.otomasyon').subscribe(title => {
      this.titleService.setTitle(title);
    });
  }

  private hataVer(baslik: string, mesaj: string) {
    this.notification.error({
      title: baslik,
      msg: mesaj,
      showClose: true,
      timeout: 10000,
      iconClass: 'fa-times-circle',
    });
  }

  sureBitti() {

    const user = this.authService.getUser();
    this.apiService.get('kullanici/giris-yapan-kullanici-ayni-mi/', { userId: user.id })
      .subscribe(result => {
        this.girisYapanKullaniciAyniMi = result.data;
        if (!this.girisYapanKullaniciAyniMi) {
          this.sayacCalisacakMi = false;
          this.oturumModal.openBox();
        }
      });    
  }
}
